import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphAccordionItem as Type } from '../../../types/uncinc_profile/paragraphs';
import { AccordionItem, WysiwygField } from '../../../components';

interface ParagraphAccordionItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  className?: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphAccordionItem: React.FC<ParagraphAccordionItemProps> = ({ className, entity }) => {
  const paragraph = entity.toJS();

  return (
    <AccordionItem
      className={c('ParagraphAccordionItem', className)}
      label={paragraph.field_label[0]?.value}
      title={paragraph.field_title[0].value}
    >
      <WysiwygField
        className="px-1"
        html={paragraph.field_body[0].processed}
      />
    </AccordionItem>
  );
};

export default ParagraphAccordionItem;
